import {useAppSelector} from '@/store';
import {getSalesTargetDisplayContentConfig} from '@/utils/salesTargetDisplayContentConfig';
import {AddSalesTargetDisplayContent} from './AddSalesTargetDisplayContent';
import {AddSalesTargetDisplayContentV2} from './AddSalesTargetDisplayContentV2';
import {CdaSuperTargetDisplayContent} from './CdaSuperTargetDisplayContent';
import {RackChallengeDisplayContent} from './RackChallengeDisplayContent';

export const SalesTargetDisplayContentRouter = () => {
  const targetType = useAppSelector((state) => state.salesTarget.targetType);
  const {version} = getSalesTargetDisplayContentConfig(targetType);
  if (version === 'rack') return <RackChallengeDisplayContent />;
  if (version === 'cda') return <CdaSuperTargetDisplayContent />;
  if (version === 'v2') return <AddSalesTargetDisplayContentV2 />;
  return <AddSalesTargetDisplayContent />;
};
